export default function Logo(): React.ReactElement {
  return (
    <svg width="136" height="40" viewBox="0 0 136 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Evolent</title>
      <path
        d="M0.0923462 29.5879C0.0923462 22.6464 4.45157 19.1757 10.3934 19.1757C16.2243 19.1757 20.1115 22.9241 20.1115 29.1992C20.1115 29.6156 20.0837 30.3098 20.0004 30.7263H4.4238C4.72923 34.558 7.17262 36.6681 10.3657 36.6681C12.3093 36.6681 14.1418 35.7796 15.0303 34.1692H19.3063C18.1679 37.8065 14.7249 40 10.3934 40C4.03508 40 0.0923462 36.0573 0.0923462 29.5879ZM15.6689 27.6998C15.308 24.3402 13.0312 22.4521 10.1991 22.4521C7.45027 22.4521 5.00689 24.2846 4.53487 27.6998H15.6689Z"
        fill="#0D1117"
      />
      <path
        d="M29.3852 39.4447L21.1388 19.7032H25.8867L31.6065 34.0026C31.662 34.1137 31.7453 34.1692 31.8564 34.1692C31.9674 34.1692 32.0785 34.0859 32.1063 34.0026L37.7427 19.7032H42.2963L34.0776 39.4447H29.3852Z"
        fill="#0D1117"
      />
      <path
        d="M43.518 29.5879C43.518 22.5354 47.9605 19.1757 54.069 19.1757C60.233 19.1757 64.62 22.5354 64.62 29.5879C64.62 36.6404 60.2052 40 54.069 40C47.9605 40 43.518 36.6126 43.518 29.5879ZM60.233 29.5879C60.233 24.9232 57.7063 22.6464 54.069 22.6464C50.4039 22.6464 47.9328 24.8955 47.9328 29.5879C47.9328 34.2803 50.4317 36.4738 54.0968 36.4738C57.7618 36.4738 60.233 34.2525 60.233 29.5879Z"
        fill="#0D1117"
      />
      <path d="M68.8959 39.4447V12.7341H73.2274V39.4447H68.8959Z" fill="#0D1117" />
      <path
        d="M77.4478 29.5879C77.4478 22.6464 81.807 19.1757 87.7489 19.1757C93.5797 19.1757 97.4669 22.9241 97.4669 29.1992C97.4669 29.6156 97.4391 30.3098 97.3558 30.7263H81.7792C82.0846 34.558 84.528 36.6681 87.7211 36.6681C89.6647 36.6681 91.4972 35.7796 92.3857 34.1692H96.6617C95.5233 37.8065 92.0803 40 87.7489 40C81.3905 40 77.4478 36.0573 77.4478 29.5879ZM93.0243 27.6998C92.6912 24.3402 90.3866 22.4521 87.5545 22.4521C84.8057 22.4521 82.3623 24.2846 81.8903 27.6998H93.0243Z"
        fill="#0D1117"
      />
      <path
        d="M101.076 39.4447V28.5883C101.076 22.0911 104.825 19.1757 110.878 19.1757C116.958 19.1757 120.679 21.8968 120.679 28.394V39.4447H116.348V28.394C116.348 24.5623 114.321 22.8408 110.878 22.8408C107.435 22.8408 105.408 24.7289 105.408 28.5883V39.4447H101.076Z"
        fill="#0D1117"
      />
      <path
        d="M135.95 23.5072V19.1757H129.509V12.7341H125.177V30.7818C125.177 37.279 128.898 40 134.978 40V36.335C131.535 36.335 129.509 34.6135 129.509 30.7818V23.5072H135.95Z"
        fill="#0D1117"
      />
      <path
        d="M1.42513 9.34661C2.11927 9.26331 2.61905 8.6247 2.53576 7.93055C2.45246 7.23641 1.81385 6.73663 1.1197 6.81992C0.425558 6.90322 -0.0742256 7.54183 0.00907169 8.23598C0.092369 8.90236 0.730982 9.42991 1.42513 9.34661Z"
        fill="#0D1117"
      />
      <path
        d="M7.81124 6.68113C8.9774 6.5423 9.81038 5.4872 9.67155 4.32104C9.53272 3.15488 8.47762 2.3219 7.31146 2.46073C6.1453 2.59956 5.31232 3.65466 5.45115 4.82082C5.56221 5.98699 6.64508 6.81996 7.81124 6.68113Z"
        fill="#0D1117"
      />
      <path
        d="M16.1409 5.34833C17.6125 5.18173 18.6676 3.84898 18.501 2.37739C18.3067 0.905806 16.9739 -0.149292 15.5023 0.0173023C14.0307 0.183897 12.9756 1.51665 13.1422 2.98824C13.3088 4.48759 14.6416 5.54269 16.1409 5.34833Z"
        fill="#0D1117"
      />
      <path
        d="M24.6095 6.18136C26.2477 5.987 27.4416 4.48765 27.2473 2.84947C27.0529 1.21129 25.5536 0.0173624 23.9154 0.211723C22.2772 0.406083 21.0833 1.90543 21.2776 3.54361C21.472 5.18179 22.9714 6.37572 24.6095 6.18136Z"
        fill="#0D1117"
      />
      <path
        d="M32.8282 8.48591C34.5497 8.29155 35.7714 6.73666 35.5493 5.01519C35.3549 3.29371 33.8 2.07202 32.0785 2.29414C30.3571 2.4885 29.1354 4.04339 29.3575 5.76486C29.5796 7.48634 31.1345 8.70803 32.8282 8.48591Z"
        fill="#0D1117"
      />
      <path
        d="M40.9913 10.7072C42.6573 10.5128 43.8235 9.01344 43.6291 7.3475C43.4347 5.68155 41.9354 4.51539 40.2694 4.70975C38.6035 4.90411 37.4373 6.40346 37.6317 8.04164C37.826 9.67982 39.3254 10.9015 40.9913 10.7072Z"
        fill="#0D1117"
      />
      <path
        d="M49.4043 11.1236C50.8759 10.957 51.9588 9.59651 51.7644 8.12493C51.5978 6.65334 50.2373 5.57048 48.7657 5.76484C47.2942 5.93143 46.2113 7.29196 46.4056 8.76354C46.5722 10.2351 47.905 11.2902 49.4043 11.1236Z"
        fill="#0D1117"
      />
      <path
        d="M57.6231 8.81911C58.817 8.68028 59.65 7.59741 59.5111 6.43125C59.3723 5.23732 58.2894 4.40435 57.1233 4.54318C55.9293 4.68201 55.0964 5.76487 55.2352 6.93104C55.374 8.0972 56.4291 8.95794 57.6231 8.81911Z"
        fill="#0D1117"
      />
      <path
        d="M63.5371 4.82083C64.259 4.73753 64.7588 4.07115 64.6755 3.37701C64.5922 2.6551 63.9258 2.15532 63.2317 2.23861C62.5098 2.32191 62.01 2.98829 62.0933 3.68243C62.1766 4.40434 62.8152 4.90413 63.5371 4.82083Z"
        fill="#0D1117"
      />
    </svg>
  )
}

try{ Logo.displayName ||= 'Logo' } catch {}